import type { IconData } from '@stacksjs/iconify-core'

export const basicArrowsUpRightCircle: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.343 2.343a8 8 0 1 0 11.314 11.314A8 8 0 0 0 2.343 2.343m8.84 2.475v5.657L9.767 9.06l-2.829 2.828L4.11 9.06l2.828-2.829l-1.414-1.414z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicArrowsUpRightCircle
